(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* DJ FLOWERS FIX: доки відкритий селектор мов — не ховаємо хедер.
         У розмітці немає <details>, стан визначається по aria-expanded кнопки. */
      if (this.querySelector('.dj-classic-header__language .localization-form__select[aria-expanded="true"]')) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-flower-subscription"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fs-carousel')) {
    class FsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fs-track]');
        if (!this.track) return;

        this.prevButton = this.querySelector('[data-fs-prev]');
        this.nextButton = this.querySelector('[data-fs-next]');
        this.frame = 0;

        this.handleUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };
        this.handlePrev = () => this.scrollByStep(-1);
        this.handleNext = () => this.scrollByStep(1);
        this.handleBlockSelect = (event) => {
          event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        };

        this.track.addEventListener('scroll', this.handleUpdate, { passive: true });
        if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleUpdate);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.handleUpdate);
        }

        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;

        cancelAnimationFrame(this.frame);
        this.track.removeEventListener('scroll', this.handleUpdate);
        if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        } else {
          window.removeEventListener('resize', this.handleUpdate);
        }
      }

      scrollByStep(direction) {
        const slide = this.track.firstElementChild;
        if (!slide) return;

        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap) || 0;
        const rtl = styles.direction === 'rtl' ? -1 : 1;
        const step = slide.getBoundingClientRect().width + gap;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.track.scrollBy({
          left: direction * rtl * step,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;
        const position = Math.abs(scrollLeft);

        this.toggleAttribute('data-static', maxScroll <= 1);
        if (this.prevButton) this.prevButton.disabled = position <= 1;
        if (this.nextButton) this.nextButton.disabled = position >= maxScroll - 1;
      }
    }

    customElements.define('fs-carousel', FsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
